export default __webpack_public_path__ + "static/media/896.31862283.png";